export default function useDateUtility() {
    return {
        daysOfWeek: [
            { "name": "Monday", "value": 1 },
            { "name": "Tuesday", "value": 2 },
            { "name": "Wednesday", "value": 3 },
            { "name": "Thursday", "value": 4 },
            { "name": "Friday", "value": 5 },
            { "name": "Saturday", "value": 6 },
            { "name": "Sunday", "value": 7 }
        ],
        getDayOfWeek: function (value) {
            let valueFormatted = parseInt(value);
            return this.daysOfWeek.find(x => x.value === valueFormatted);
        },
        toDateString: function (date) {
            var d = new Date(date);
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
        },
        toDateTimeString: function (date) {
            var d = new Date(date.toString().includes("T")? date : `${date}T00:00:00`);
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}T${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}:00`;
        },
        toTimeSpanString: function (timeSpan) {
            var parts = timeSpan.split(":");
            return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}:00`;
        }
    };
};